import { render, staticRenderFns } from "./Redeem01.vue?vue&type=template&id=0bc79b1c&scoped=true&"
import script from "./Redeem01.vue?vue&type=script&lang=js&"
export * from "./Redeem01.vue?vue&type=script&lang=js&"
import style0 from "./Redeem01.vue?vue&type=style&index=0&id=0bc79b1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc79b1c",
  null
  
)

export default component.exports